import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';

import { L10nConfig, L10nLoader, TranslationModule, StorageStrategy, ProviderType, LogLevel } from 'angular-l10n';

import { Translator } from './translator'

const l10nConfig: L10nConfig = {
    logger: {
        level: LogLevel.Warn
    },
    locale: {
        languages: [
            { code: 'en', dir: 'ltr' },
            { code: 'ru', dir: 'ltr' }
        ],
        language: 'en',
        storage: StorageStrategy.Disabled
    },
    translation: {
        providers: [
            { type: ProviderType.Static, prefix: '../assets/locales/locale-' }
        ],
        caching: true,
        composedKeySeparator: '.',
        missingValue: 'No key'
    }
  };

@NgModule({
    declarations: [
        Translator
    ],
    imports: [
        CommonModule,
        TranslationModule.forRoot(l10nConfig),
    ],
    exports: [
        Translator
    ]
})

export class TranslatorModule {
    constructor(public l10nLoader: L10nLoader) {
        this.l10nLoader.load().then(() => { 
        });
    }
}
